export const MMB_KEYS = Object.freeze({
  PLAN_AND_PREPARE: "PLAN_AND_PREPARE",
  BAGGAGE: "BAGGAGE",
  SEATING: "SEATING",
  INSURANCE: "INSURANCE",
  MEALS: "MEALS",
  PETS: "PETS",
  SPECIAL_ASSISTANCE: "SPECIAL_ASSISTANCE",
  SPORTS_EQUIPMENT: "SPORTS_EQUIPMENT",
  MUSICAL_EQUIPMENT: "MUSICAL_EQUIPMENT",
  ACCOMMODATION: "ACCOMMODATION",
  CAR_RENTAL: "CAR_RENTAL",
  AIRPORT_PARKING: "AIRPORT_PARKING",
  CHANGE_FLIGHTS: "CHANGE_FLIGHTS",
  TRANSFER: "TRANSFER",
  EXTRA: "EXTRA",
  PRICE_CHANGE: "PRICE_CHANGE",
  SCHEDULE_CHANGE: "SCHEDULE_CHANGE",
  PASSENGER_EDIT: "PASSENGER_EDIT",
  ASSISTED_REFUND: "ASSISTED_REFUND",
  PRIORITY_BOARDING: "PRIORITY_BOARDING",
  INFANT: "INFANT",
  PROCESSING_FEE: "PROCESSING_FEE",
  SERVICE_PACKAGE: "SERVICE_PACKAGE",
  DISRUPTION_PROTECTION: "DISRUPTION_PROTECTION",
  // NEST MAMBO
  NEST_PASSENGER_CHANGE: "NEST_PASSENGER_CHANGE",
  NEST_BOOKING_RESTORE: "NEST_BOOKING_RESTORE",
  NEST_OTHER: "NEST_OTHER",
  NEST_CHANGE_FLIGHTS: "NEST_CHANGE_FLIGHTS",
  COVER_MORE: "COVER_MORE",
  AXA_US: "AXA_US",
  GUIDES: "GUIDES",
})

export type MMBKeys = typeof MMB_KEYS[keyof typeof MMB_KEYS]

export const BOOKING_STATUSES = {
  CLOSED: "closed",
  CONFIRMED: "confirmed",
  REFUNDED: "refunded",
  REFUNDING: "refunding",
  LOCKED: "locked", // frontend specific status
} as const

export const DISPLAY_STATUSES = {
  CANCELLED: "cancelled",
  CHANGE_IN_PROGRESS: "changeInProgress",
  CONFIRMED: "confirmed",
  LOCKED: "locked",
  PROCESSING: "processing",
  REFUNDED: "refunded",
  REFUNDING: "refunding",
  TRAVELED: "traveled",
  NOT_BOOKED: "notBooked",
} as const

export const ACTIONS = {
  INVALIDATE: "invalidate",
  REQUEST_FAST_REFUND: "requestFastRefund",
  CHANGE_INSURANCE: "changeInsurance",
  CANCEL_BOOKING: "cancelBooking",
  ADDITIONAL_CONTACTS: "additionalContacts",
  UNSPECIFIED: "unspecified",
} as const

export const CUSTOMER_SUPPORT_ATTACHED_PAYMENT_API_CATEGORIES = {
  NEST_BOOKING_RESTORE: "booking.restore",
  NEST_OTHER: "extras.other",
  NEST_PASSENGER_CHANGE: "extras.passenger_details_change",

  // TODO will be removed from nest
  NEST_CHANGE_FLIGHTS: "extras.change_flight",
  EXTRAS_BAGS: "extras.bags",

  // Initiated by Mailing
  PRICE_CHANGE: "price_change",

  // SERVICE prefix - orders by CS agents
  SERVICE_INFANT: "service.infant",
  SERVICE_PRIORITY_BOARDING: "service.priority_boarding",
  SERVICE_UPGRADE_BAGGAGE: "service.upgrade_baggage",
  SERVICE_MEALS_ON_BOARD: "service.meals_on_board",
  SERVICE_SPECIAL_ASSISTANCE: "service.special_assistance",
  SERVICE_PETS: "service.travelling_with_pets",
  SERVICE_OTHER: "service.other",
  SERVICE_SPORTS_EQUIPMENT: "service.sports_equipment",
  SERVICE_BAGGAGE: "service.baggage",
  SERVICE_MUSICAL_EQUIPMENT: "service.musical_equipment",
  SERVICE_SEATING: "service.allocated_seating",
} as const

export const API_CATEGORIES = Object.freeze({
  ...CUSTOMER_SUPPORT_ATTACHED_PAYMENT_API_CATEGORIES,
  SEATING: "seating",
  BAGS: "bags",
  PRIORITY_BOARDING: "priority_boarding",
  FLIGHTS: "flights",
  CARRIER_ITINERARY_CHANGE: "carrier_itinerary_change",
  UPDATE_INSURANCES: "update_insurances",
  PASSENGER_EDIT: "passenger_details_change",
  SERVICE_PACKAGE: "service_package",
  ASSISTED_REFUND: "assisted_refund",
  DISRUPTION_PROTECTION: "guarantee",
  // only refund
  COVER_MORE: "cover_more_insurance",
  AXA_US: "axa_us_insurance",
  // order item category
  HANDLING_FEE: "handling_fee",
})

export const CONTEXTS = {
  MMB: "MMB",
} as const
